import { withStyles } from '@material-ui/core';

import DevicePreview from './component';
import styles from './styles';

export default withStyles(styles)(DevicePreview);
